import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAspectRatio219: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAspectRatio219"><Path d="M0 6V18H24V6H0Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAspectRatio219;
